module.exports = __webpack_public_path__ + "app/modals/set-unit-modal.view.html";